module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2klEQVQ4jc2SsWqCQRCEP38OhEDyBKJPICnSp5IUMWAjqSxjoSn/x0mbIoWVReq8RWoR0qSLKLGZCQcryF96hVlYdpm5Yeduj7NHq67rX6B9opF9sk8W52gn2UWvUMlC1q2staxnWV1Z28AfZV1Hn2tf1jDOZg0HBxtAwA7oAEtgAHwDPzEs1w+gB6xCQyWZRo4lv0p+k3zX4O4lT4+xKjto5I3sL9kL2aMG9y775RhLUnbOZXYDXAAJmACfgV/FFXJ9CH4ZHK2n2bxoDcVrTLb3JT+xaPo/COAPwxK+oXoGCz4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/health/information_imei_leave.png
// module id = TgC3
// module chunks = 4